import i18n from "@/common/i18n";
import Layout from '@/layout/index';
const router = [{
  path: '/eventhub/other',
  component: Layout,
  redirect: '/cms/other/msgList',
  meta: {
    auth: true,
    title: i18n.t("lang.k_011001"),
    name: 'other',
    icon: 'vh-icon-s-help'
  },
  hidden: true,
  children: [{
    path: 'msgList',
    component: () => import('@/views/PlatformModule/Message/list'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_011002"),
      name: 'msgList',
      icon: 'table'
    }
  }, {
    path: 'msgDetail/:str(\\d+)',
    component: () => import('@/views/PlatformModule/Message/detail'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_011003"),
      name: 'msgDetail',
      icon: 'table',
      activeMenu: '/other/msgList'
    },
    hidden: true
  }, {
    path: 'downloadList',
    component: () => import('@/views/PlatformModule/download'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_011004"),
      name: 'downloadList',
      icon: 'table'
    }
  }, {
    path: 'info2',
    component: () => import('@/views/AccountModule/info'),
    meta: {
      title: i18n.t("lang.k_011005"),
      name: 'accountInfo'
    }
  }]
}, {
  path: '/eventhub/acc',
  component: Layout,
  redirect: '/eventhub/acc/info',
  hidden: true,
  meta: {
    auth: true,
    title: i18n.t("lang.k_011006"),
    name: 'accountMgr',
    icon: 'saasicon_account_img'
  },
  children: [{
    path: 'info',
    component: () => import('@/views/AccountModule/info'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_011005"),
      name: 'accountInfo',
      activeMenu: '/acc/info'
    }
  }]
}, {
  path: '/datahub/site',
  name: 'cms',
  component: Layout,
  hidden: true,
  meta: {
    title: i18n.t("lang.k_011007"),
    name: 'Datahub',
    icon: 'saasicon_datahub_user_operation_img'
  },
  children: [{
    path: '/datahub/site/:id',
    // component: () => import('@/views/DataHub/SiteAnalysis/index.vue'),
    component: () => import('@/views/DataHub/index.vue'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_011007"),
      activeMenu: '/cms/website'
    }
  }]
}];
export default router;